/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Not_ResolvableInputs */

const vi_einvoice_err_not_resolvable = /** @type {(inputs: Einvoice_Err_Not_ResolvableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn của đơn này không thể đóng tay ở trạng thái hiện tại. Tải lại trang để xem tình trạng mới.`)
};

/**

* @param {Einvoice_Err_Not_ResolvableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_not_resolvable = /** @type {((inputs?: Einvoice_Err_Not_ResolvableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Not_ResolvableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_not_resolvable(inputs)
});